import { AssetType, CESIUM_PICKABLE_ENTITY } from "../types";
export class GenericHandler {
    _site;
    _viewer;
    _handler;
    _cesiumPicker;
    _trenchHandler;
    _roadHandler;
    _flatGroundHandler;
    _arbitraryHandler;
    _lineWorkCrossSectionHandler;
    _lineWorkProfileHandler;
    constructor(args, trenchHandler, roadHandler, flatGroundHandler, arbitraryHandler, lineWorkCrossSectionHandler, lineWorkProfileHandler) {
        this._site = args.site;
        this._viewer = args.viewer;
        this._handler = args.handler;
        this._cesiumPicker = args.cesiumPicker;
        this._trenchHandler = trenchHandler;
        this._roadHandler = roadHandler;
        this._flatGroundHandler = flatGroundHandler;
        this._arbitraryHandler = arbitraryHandler;
        this._lineWorkCrossSectionHandler = lineWorkCrossSectionHandler;
        this._lineWorkProfileHandler = lineWorkProfileHandler;
    }
    async leftDownHandler(click) {
        const pickedEntity = this._cesiumPicker.getAllowPickedEntity(click.position);
        if (pickedEntity && pickedEntity.pickInfo) {
            const type = pickedEntity.pickInfo.assetType;
            switch (type) {
                case AssetType.Road_Data:
                    if (this._roadHandler.editHandler.roadUnderEdit) {
                        await this._roadHandler.editHandler.pickControlPoint(click);
                    }
                    break;
                case AssetType.Trench_Data:
                    if (this._trenchHandler.editHandler.trenchUnderEdit) {
                        await this._trenchHandler.editHandler.pickControlPoint(click);
                    }
                    break;
                case AssetType.Flat_Ground_Data:
                    if (this._flatGroundHandler.editHandler.flatGroundUnderEdit) {
                        if (this._flatGroundHandler.editHandler.isFlatGroundToUniformDrag) {
                            this._flatGroundHandler.editHandler.dragFlatGroundUniformlyOnLeftDown(click);
                        }
                        else if (this._flatGroundHandler.editHandler
                            .isFlatGroundPointToVerticalDrag) {
                            this._flatGroundHandler.editHandler.pickArrowEntityForVerDrag(click);
                        }
                        else {
                            await this._flatGroundHandler.editHandler.pickControlPoint(click);
                        }
                    }
                    break;
                case AssetType.ArbitraryLine_CROSS_SECTION:
                case AssetType.ArbitraryLine_Data:
                    this._lineWorkCrossSectionHandler.onClick(click);
                    if (this._lineWorkProfileHandler.currentLineId !==
                        pickedEntity.pickInfo.owner.id) {
                        this._lineWorkProfileHandler.renderProfileData(pickedEntity.pickInfo.owner);
                    }
                    break;
                case AssetType.ALIGNMENT:
                    if (pickedEntity.pickInfo.pickableType ===
                        CESIUM_PICKABLE_ENTITY.ALIGNMENT_IP_POINT) {
                        if (this._roadHandler.editHandler.roadUnderEdit) {
                            await this._roadHandler.editHandler.pickControlPoint(click);
                        }
                        if (this._trenchHandler.editHandler.trenchUnderEdit) {
                            await this._trenchHandler.editHandler.pickControlPoint(click);
                        }
                    }
                    else if (pickedEntity.pickInfo.pickableType ===
                        CESIUM_PICKABLE_ENTITY.ALIGNMENT_POINT) {
                        const roadUnderEdit = this._roadHandler.editHandler.roadUnderEdit;
                        const trenchUnderEdit = this._trenchHandler.editHandler.trenchUnderEdit;
                        if (roadUnderEdit &&
                            pickedEntity.pickInfo.owner ===
                                roadUnderEdit.cesiumRenderableAlignment) {
                            await this._roadHandler.editHandler.pickControlPoint(click);
                        }
                        else if (trenchUnderEdit &&
                            pickedEntity.pickInfo.owner ===
                                trenchUnderEdit.cesiumRenderableAlignment) {
                            await this._trenchHandler.editHandler.pickControlPoint(click);
                        }
                        else {
                            this._lineWorkCrossSectionHandler.onClick(click);
                            if (this._lineWorkProfileHandler.currentLineId !==
                                pickedEntity.pickInfo.owner.id) {
                                this._lineWorkProfileHandler.renderProfileData(pickedEntity.pickInfo.owner);
                            }
                        }
                    }
                    break;
                default:
                    console.warn(`assetType is invalid. pickedEntity: ${pickedEntity}`);
                    break;
            }
        }
    }
}
//# sourceMappingURL=generic-handler.js.map